// Helpers d'upload de fichiers (liasse fiscale, factures...).
// Extraits pour être testables : progression, formatage de taille, message d'erreur.

/**
 * Pourcentage d'un événement de progression axios (0-100), ou null si la taille
 * totale n'est pas connue (upload en cours sans Content-Length exploitable).
 */
export function computeUploadPercent(progressEvent) {
  if (!progressEvent || !progressEvent.total) return null;
  return Math.round((progressEvent.loaded / progressEvent.total) * 100);
}

/** Taille lisible : "18.0 Mo" au-delà de 1 Mo, sinon "500 Ko". */
export function formatFileSize(bytes) {
  const mo = bytes / (1024 * 1024);
  if (mo >= 1) return `${mo.toFixed(1)} Mo`;
  return `${Math.round(bytes / 1024)} Ko`;
}

/**
 * Message utilisateur clair à partir d'une erreur d'upload. Distingue le timeout
 * (fichier trop lourd / connexion lente) et l'erreur réseau du hang muet, qui
 * laissait auparavant l'UI figée sur « envoi en cours ».
 */
export function uploadErrorMessage(error) {
  if (!error) return "L'upload de la liasse a échoué.";
  if (error.code === 'ECONNABORTED') {
    return "L'envoi a été interrompu : fichier trop volumineux ou connexion trop lente. Réessayez.";
  }
  if (error.response?.data?.message) return error.response.data.message;
  if (error.message === 'Network Error') {
    return "Problème de réseau pendant l'envoi. Vérifiez votre connexion et réessayez.";
  }
  return "L'upload de la liasse a échoué.";
}
